import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { LocationService } from 'src/app/_service/location.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-floor',
  templateUrl: './add-floor.component.html',
  styleUrls: ['./add-floor.component.css']
})
export class AddFloorComponent implements OnInit {

  
  authorities;
  selectedAuthority;
  newSiteName;
  level1Authorities;
  selectedLevel1Authority;
  level2Authorities;
  selectedLevel2Authority;
  level3Authorities;
  selectedLevel3Authority;
  level4Authorities;
  selectedLevel4Authority;

  authorityInput = { 
    rootAuthorityUnitId: null,
    parentAuthorityUnitId: null,
    name: ''
  };

  locationExists: any = {};
  locationAdded: any = {};
  model: any = {};
  newFloorAliasName: any;
  isModified = false;

  locationForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private locationService: LocationService,
    private alertify: AlertifyService,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {
    this.locationForm = fb.group({

      siteFormControl: new FormControl('', [
        Validators.required
      ]),
      serviceareaFormControl: new FormControl('', [
        Validators.required
      ]),
      locationFormControl: new FormControl('', [
        Validators.required
      ]),
      sublocationFormControl: new FormControl('', [
        Validators.required
      ]),
      departmentFormControl: new FormControl('', [
        Validators.required
      ]),
      subdepartmentFormControl: new FormControl('', [
        Validators.required,
        this.WhitespaceValidator
      ]),
      aliasFormControl: new FormControl('', []).clearValidators(),
    });
   }

   public WhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
}

  ngOnInit() {
    this.getAllTopAuthority();
  }

  getAllTopAuthority() {
    return this.locationService.getAllTopAuthorityNames().subscribe(res => {
      this.authorities = res;
    })
  }

    getLevel1DropDown() {
    return this.locationService.levelDropDown(this.selectedAuthority).subscribe(res => {
      this.level1Authorities = res;
    });
  }

  getLevel2DropDown() {
    return this.locationService.levelDropDown(this.selectedLevel1Authority).subscribe(res => {
      this.level2Authorities = res;
    });
  }

  getLevel3DropDown() {
    return this.locationService.levelDropDown(this.selectedLevel2Authority).subscribe(res => {
      this.level3Authorities = res;
    });
  }

  getLevel4DropDown() {
    return this.locationService.levelDropDown(this.selectedLevel3Authority).subscribe(res => {
      this.level4Authorities = res;
    });
  }

  onUserSelectTop() {
    this.getLevel1DropDown();
  }
  onUserSelectLevel1() {
    this.getLevel2DropDown();
  }

  onUserSelectLevel2() {
    this.getLevel3DropDown();
  }

  onUserSelectLevel3() {
    this.getLevel4DropDown();
  }

  addDepartment() {
    if (this.selectedAuthority && this.newSiteName && 
      this.selectedLevel1Authority && this.selectedLevel2Authority
       && this.selectedLevel3Authority && this.selectedLevel4Authority) {

      this.model.rootAuthorityUnitId = this.selectedAuthority;
      this.model.parentAuthorityUnitId = this.selectedLevel2Authority;
      this.model.parentAuthorityUnitId = this.selectedLevel3Authority;
      this.model.parentAuthorityUnitId = this.selectedLevel4Authority;
      this.model.name = this.newSiteName.trim();

      if (this.newFloorAliasName !== undefined) {
        this.model.alias = this.newFloorAliasName.trim();
      }

      return this.locationService.insertNewSite(this.model).subscribe(
        res => {
          this.locationExists = res.headers.get('locationexists');
          if (this.locationExists) {
            this.alertify.error(this.locationExists);
          }
          this.locationAdded = res.headers.get('locationadded');
          if (this.locationAdded) {
            this.alertify.success(this.locationAdded);
            this.isModified = true;
            this.dialog.closeAll();
          }
     }, error => {
        this.alertify.error('Something went wrong');
      });

    }
  }
}